import angular from 'angular';
import { slugifyFilter } from './slugify.filter';

export const slugifyModule = angular
  .module('bit.services.slugify', [])
  .filter('slugify', slugifyFilter);
